import { render, staticRenderFns } from "./addPressDifAlarmDialog.vue?vue&type=template&id=606a8a4f&scoped=true"
import script from "./addPressDifAlarmDialog.vue?vue&type=script&lang=js"
export * from "./addPressDifAlarmDialog.vue?vue&type=script&lang=js"
import style0 from "./addPressDifAlarmDialog.vue?vue&type=style&index=0&id=606a8a4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606a8a4f",
  null
  
)

export default component.exports